import { usePage } from "@inertiajs/react";
import { useState } from "react";
import classNames from "classnames";

import { useToast } from "/utils/toast-context.jsx";

export default function Switch({
  name,
  onChange,
  value,
  url,
}) {
  const [processing, setProcessing] = useState(false);
  const props = usePage().props;
  const { successToast, errorToast } = useToast();

  const handleChange = () => {
    // Not saved yet: the value stays with the caller until the create sends it.
    if (!url) {
      if (typeof onChange === "function")
        onChange({ [name]: !value });

      return;
    }

    setProcessing(true);
    fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({ authenticity_token: props.csrf_token, [name]: !value }),
    }).then(
      (response) => {
        if (!response.ok) {
          errorToast("Не удалось сохранить");
          return;
        }

        // Only a save that landed may flip the switch.
        if (typeof onChange === "function")
          onChange({ [name]: !value });

        successToast("Сохранено");
      },
      () => errorToast("Не удалось сохранить"),
    ).finally(() => setProcessing(false));
  };

  return (
    <div
      className={classNames("inpt-switch", { "inpt-switch--checked": value })}
      onClick={handleChange}
      disabled={processing}
    >
      <div className="inpt-switch-tumbler"></div>
    </div>
  );
}
